// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	RightIcon: 'right-icon',
	DoubleUpIcon: 'double-up-icon',
	SearchIcon: 'search-icon',
	BackIcon: 'back-icon',
	Icon: 'icon',
	Icon1: 'icon-1',
	DownIcon: 'down-icon',
	Link: 'link',
	MenuItemLink: 'menu-item-link',
	GoToPreviousPageButton: 'go-to-previous-page-button',
	ToggleSelectedGroupButton: 'toggle-selected-group-button',
	ToggleSideNavDiv: 'toggle-side-nav-div',
	ToggleAllSelectedGroupsDiv: 'toggle-all-selected-groups-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
